export default __webpack_public_path__ + "images/video-calling-step-3_2x.12aba076f07f8dcc45ddf3554d1c8483.png";